import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/close-icon-2.svg'


const _hoisted_1 = { class: "max-w-[854px] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-h-[calc(100vh-48px)] overflow-y-hidden mx-auto flex flex-col items-start justify-between p-5 bg-white rounded-primary-radius" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "w-full flex items-center justify-between mb-[13px]" }
const _hoisted_4 = { class: "mb-[24px]" }
const _hoisted_5 = { class: "max-h-[700px] overflow-y-auto" }



type Emits = {
  (event: "onClose"): void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'QuestionnaireModal',
  emits: ["onClose"],
  setup(__props, { emit: __emit }) {

const emits = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _renderSlot(_ctx.$slots, "header")
        ]),
        _createElementVNode("img", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClose'))),
          src: _imports_0,
          alt: "Close icon",
          class: "cursor-pointer"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "progress-bar")
      ]),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "content")
      ])
    ])
  ]))
}
}

})